import { CSSResultGroup, TemplateResult, html, nothing } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './se-pro-listing.css.lit';

import { SlotController } from '../../controllers/slot-controller';
import '../se-heading/se-heading';

/**
 * The SeProListing component
 * @element se-pro-listing
 * slot - default slot for facet markup.
 */
@customElement('se-pro-listing')
export class SeProListing extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  slots = new SlotController(this, true);

  @property({ type: String })
  heading: string;

  render(): TemplateResult {
    return html`
      ${this.hasHeading()}
      <slot></slot>
    `;
  }

  hasHeading() {
    return this.heading
      ? html`<se-heading level-style="medium" level="h5"
          >${this.heading}</se-heading
        >`
      : nothing;
  }
}
